<template>
    <div>
        <!-- <b-row class="mt-2">
            <b-col>
                <customer-information
                    :value.sync="value"
                    :readonly="readonly"
                    ref="TruckSaleCustomer"
                />
            </b-col>
        </b-row> -->
        <b-row class="mt-2">
            <b-col>
                <routing-details
                    :value.sync="value"
                    :readonly="readonly"
                    ref="Routing"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="mt-2">
                <cargo-details
                    :value.sync="value"
                    :readonly="readonly"
                    ref="Cargo"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <additional-service
                    :value.sync="value"
                    :readonly="readonly"
                    cols="12"
                ></additional-service>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <notes
                    :value.sync="value"
                    :readonly="readonly"
                    cols="12"
                ></notes>
            </b-col>
        </b-row>
         <b-row>
            <b-col>
                <billing-information
                    :value.sync="value"
                    :readonly="readonly"
                    cols="12"
                    ref="Billing"
                >
                </billing-information>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <attach-files
                    :value.sync="value"
                    :readonly="readonly"
                    cols="12"
                    ref="AttachFile"
                ></attach-files>
            </b-col>
        </b-row>   
        <b-row class="mt-2" v-if="value && value.status_id && value.status_id != 5 && value.status_id !=6">
            <ChatWithWR1
              :request_quotation="value"
            />
        </b-row>
    </div>
</template>

<script>
import CustomerInformation from "./components/CustomerInformation.vue";
import RoutingDetails from "./components/RoutingDetails.vue";
import CargoDetails from "./components/CargoDetails.vue";
import AdditionalService from "./components/AdditionalService.vue";
import Notes from "./components/Notes.vue";
import BillingInformation from "./components/BillingInformation.vue";
import AttachFiles from "./components/AttachFiles.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ChatWithWR1 from '../../quotation/ChatWithWR1.vue'
export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        CustomerInformation,
        RoutingDetails,
        CargoDetails,
        AdditionalService,
        Notes,
        // FreightTerms,
        // Remarkable,
        AttachFiles,
        BillingInformation,
        ChatWithWR1
    },

    props: {
        value: {
            type: Object,
        },
        readonly: false,
    },
    created() {},
    mounted() {},
};
</script>

<style lang="scss">
.custom_list_btn {
    justify-content: end;
    gap: 20px;
    display: flex;
    margin-right: 0px;
}
.mt-8 {
    margin-top: 80px !important;
}
.mt-15 {
    margin-top: 120px !important;
    @media (max-width: 992px) {
        margin-top: 220px !important;
    }
}
</style>
